import { render, staticRenderFns } from "./DashboardItem.vue?vue&type=template&id=707f6f9c&scoped=true&"
import script from "./DashboardItem.vue?vue&type=script&lang=js&"
export * from "./DashboardItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardItem.vue?vue&type=style&index=0&id=707f6f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707f6f9c",
  null
  
)

component.options.__file = "DashboardItem.vue"
export default component.exports